"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.UnderwritingUpdatesPage = void 0;
var jsx_runtime_1 = require("react/jsx-runtime");
var components_1 = require("@athena-portal/components");
var core_1 = require("@athena-portal/core");
var Types_1 = require("../../Types");
var React = require("react");
var SupportPortalTemplates_1 = require("../../SupportPortalTemplates");
var UnderwritingUpdatesTableRow_1 = require("./UnderwritingUpdatesTableRow");
var UnderwritingUpdatesPage = /** @class */ (function (_super) {
    __extends(UnderwritingUpdatesPage, _super);
    function UnderwritingUpdatesPage(props) {
        var _this = _super.call(this, props) || this;
        _this.supportPortalTemplates = new SupportPortalTemplates_1.SupportPortalTemplates();
        _this.state = {
            claims: []
        };
        document.title = "Underwriting updates";
        return _this;
    }
    UnderwritingUpdatesPage.prototype.componentDidMount = function () {
        var _this = this;
        this.supportPortalService
            .getUnderwritingUpdates(this.props.params.id)
            .subscribe(function (claims) {
            _this.setState({ claims: claims });
        });
    };
    UnderwritingUpdatesPage.prototype.render = function () {
        return ((0, jsx_runtime_1.jsxs)(jsx_runtime_1.Fragment, { children: [this.supportPortalTemplates.renderBackLink("Customer details", true, "/customers/".concat(this.props.params.id)), (0, jsx_runtime_1.jsx)("div", { className: "row panel-border", children: (0, jsx_runtime_1.jsxs)("div", { className: "col-12 mb-3", children: [(0, jsx_runtime_1.jsxs)("h2", { children: ["Underwriting updates for ", this.props.location.state.customerName] }), this.state.claims && this.state.claims.length > 0
                                ? (0, jsx_runtime_1.jsx)("div", { className: "text-muted", children: this.renderUnderwritingUpdateTable() })
                                : (0, jsx_runtime_1.jsx)("p", { className: "text-muted", children: "This customer has no claims" })] }) })] }));
    };
    UnderwritingUpdatesPage.prototype.renderUnderwritingUpdateTable = function () {
        return ((0, jsx_runtime_1.jsxs)("table", { className: "table table-striped table-hover table-sm", children: [(0, jsx_runtime_1.jsx)("thead", { children: (0, jsx_runtime_1.jsxs)("tr", { children: [(0, jsx_runtime_1.jsx)("th", { scope: "col", children: "Claim number" }), (0, jsx_runtime_1.jsx)("th", { scope: "col", children: "Policy number" }), (0, jsx_runtime_1.jsx)("th", { scope: "col", children: "Loss cause" }), (0, jsx_runtime_1.jsx)("th", { scope: "col", children: "Loss date" }), (0, jsx_runtime_1.jsx)("th", { scope: "col", children: "Updated by" })] }) }), (0, jsx_runtime_1.jsx)("tbody", { children: this.renderTableRows() })] }));
    };
    UnderwritingUpdatesPage.prototype.renderTableRows = function () {
        var _this = this;
        return this.state.claims.map(function (claim, index) {
            return (0, jsx_runtime_1.jsx)(UnderwritingUpdatesTableRow_1.default, __assign({ claim: claim }, _this.props), index);
        });
    };
    __decorate([
        (0, core_1.lazyInject)(Types_1.Types.SupportPortalService),
        __metadata("design:type", Object)
    ], UnderwritingUpdatesPage.prototype, "supportPortalService", void 0);
    UnderwritingUpdatesPage = __decorate([
        components_1.authorize,
        __metadata("design:paramtypes", [Object])
    ], UnderwritingUpdatesPage);
    return UnderwritingUpdatesPage;
}(React.Component));
exports.UnderwritingUpdatesPage = UnderwritingUpdatesPage;
exports.default = (0, components_1.withRouter)(UnderwritingUpdatesPage);
//# sourceMappingURL=UnderwritingUpdatesPage.js.map